var prisma = prisma || {};
(function ($) {
    if (!sweetAlert || !$) {
        return;
    }

    /* PADRÕES *************************************************/

    prisma.libs = prisma.libs || {};
    prisma.libs.sweetAlert = {
        config: {
            'default': {

            },
            info: {
                type: 'info'
            },
            success: {
                type: 'success'
            },
            warn: {
                type: 'warning'
            },
            error: {
                type: 'error'
            },
            confirm: {
                type: 'warning',
                title: 'Tem certeza?',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonColor: "#DD6B55",
                confirmButtonText: 'Sim'
            }
        }
    };

    /* MENSAGEM **************************************************/

    var showMessage = function (type, message, title) {
        if (!title) {
            title = message;
            message = undefined;
        }

        var opts = $.extend(
            {},
            prisma.libs.sweetAlert.config.default,
            prisma.libs.sweetAlert.config[type],
            {
                title: title,
                text: message
            }
        );

        return $.Deferred(function ($dfd) {
            sweetAlert(opts, function () {
                $dfd.resolve();
            });
        });
    };

    prisma.message.info = function (message, title) {
        return showMessage('info', message, title);
    };

    prisma.message.success = function (message, title) {
        return showMessage('success', message, title);
    };

    prisma.message.warn = function (message, title) {
        return showMessage('warn', message, title);
    };

    prisma.message.error = function (message, title) {
        return showMessage('error', message, title);
    };

    prisma.message.confirm = function (message, titleOrCallback, callback) {
        var userOpts = {
            text: message
        };

        if ($.isFunction(titleOrCallback)) {
            callback = titleOrCallback;
        } else if (titleOrCallback) {
            userOpts.title = titleOrCallback;
        };

        var opts = $.extend(
            {},
            prisma.libs.sweetAlert.config.default,
            prisma.libs.sweetAlert.config.confirm,
            userOpts
        );

        return $.Deferred(function ($dfd) {
            sweetAlert(opts, function (isConfirmed) {
                callback && callback(isConfirmed);
                $dfd.resolve(isConfirmed);
            });
        });
    };

    prisma.event.on('prisma.dynamicScriptsInitialized', function () {
        prisma.libs.sweetAlert.config.confirm.title = 'Você tem certeza?';
        prisma.libs.sweetAlert.config.confirm.cancelButtonText = 'Cancelar';
        prisma.libs.sweetAlert.config.confirm.confirmButtonText = 'Sim';
    });

})(jQuery);